import { render } from "./SurveyHistory.vue?vue&type=template&id=50086034&scoped=true"
import script from "./SurveyHistory.vue?vue&type=script&lang=js"
export * from "./SurveyHistory.vue?vue&type=script&lang=js"

import "./SurveyHistory.vue?vue&type=style&index=0&id=50086034&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50086034"]])

export default __exports__